import type { IconData } from '@stacksjs/iconify-core'

export const contentShare: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12.5 7A3.5 3.5 0 1 0 9 3.573L5.659 5.244a3.5 3.5 0 1 0 0 5.512L9 12.427v.073a3.5 3.5 0 1 0 1.342-2.756L7 8.073v-.146l3.343-1.671A3.5 3.5 0 0 0 12.5 7\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentShare
